import * as React from "react";

export interface LogoIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  primaryColor?: string;
  secondaryColor?: string;
}

const LogoIcon: React.FC<LogoIconProps> = ({
  size = 512,
  primaryColor = "#171911",
  secondaryColor = "#ADADAD",
  className,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M448 290.697V405.313C448 428.885 428.885 448 405.313 448H290.705L65 222.295V107.687C65 84.1154 84.1154 65 107.687 65H222.303L448 290.697Z"
        fill={primaryColor}
      />

      <path
        d="M248.897 406.098H107.687C84.1154 406.098 65 386.982 65 363.41V222.2L248.897 406.098Z"
        fill={secondaryColor}
      />

      <path
        d="M448 149.751V290.961L264.103 107.064H405.313C428.885 107.064 448 126.171 448 149.751Z"
        fill={secondaryColor}
      />
    </svg>
  );
};

export default LogoIcon;
